// app/components/roles/RolesList.jsx
import React from 'react';
import { Edit2 } from 'lucide-react';

const RolesList = ({ roles, selectedRole, onSelectRole, onEditRole }) => {
    return (
        <div className="bg-white rounded-lg bxshadowhd border">
            <div className="p-4 border-b">
                <h3 className="font-semibold text-gray-900">Roles</h3>
            </div>
            <div className="p-4">
                <div className="space-y-2">
                    {roles.map((role) => (
                        <div
                            key={role.id}
                            onClick={() => onSelectRole(role)}
                            className={`p-3 rounded-lg cursor-pointer transition-all ${selectedRole?.id === role.id
                                    ? 'bg-blue-50 border-2 border-blue-500'
                                    : 'hover:bg-gray-50 border-2 border-transparent'
                                }`}
                        >
                            <div className="flex justify-between items-start">
                                <div>
                                    <h4 className="font-medium text-gray-900">{role.role_name}</h4>
                                    <p className="text-sm text-gray-500">{role.role_code}</p>
                                    {role.description && (
                                        <p className="text-xs text-gray-400 mt-1">{role.description}</p>
                                    )}
                                </div>
                                <button
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        onEditRole(role);
                                    }}
                                    className="text-blue-600 hover:text-blue-800"
                                >
                                    <Edit2 className="w-4 h-4" />
                                </button>
                            </div>
                            <div className="mt-2">
                                <span className={`inline-flex px-2 py-1 text-xs rounded-full ${role.is_active
                                        ? 'bg-green-100 text-green-800'
                                        : 'bg-red-100 text-red-800'
                                    }`}>
                                    {role.is_active ? 'Active' : 'Inactive'}
                                </span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default RolesList;